import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import slugifyFn from "slugify";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function slugify(input: string): string {
  return slugifyFn(input, {
    lower: true,
    strict: true,
  });
}

export function trimText(
  text: string | null,
  trimConfig: { trimThreshold: number; maxResultLength: number },
): { displayText: string; needsTooltip: boolean } {
  if (!text) return { displayText: "", needsTooltip: false };

  // If URL is short enough, display as is
  if (text.length < trimConfig.trimThreshold) {
    return { displayText: text, needsTooltip: false };
  }

  // Otherwise truncate to fit in one line
  return {
    displayText: `${text.substring(0, trimConfig.maxResultLength)}...`,
    needsTooltip: true,
  };
}
